// Frequently Asked Questions for Kerala Speaks.
// Kept as a separate module so it can be reused by the public About page,
// the FAQ JSON-LD schema (SEO), and a future dedicated /faq route.
// English-only by design — Malayalam expansion is queued behind P3.

export const FAQ_ITEMS = [
  {
    q: "What is Kerala Speaks?",
    a: "Kerala Speaks is a citizen-led civic participation platform where people across Kerala can share opinions, vote on public questions, and highlight issues they believe leaders should focus on.\n\nThe goal is simple: Give citizens a visible, collective voice.",
  },
  {
    q: "Is Kerala Speaks affiliated with any political party?",
    a: "No. Kerala Speaks is an independent civic platform. It is not affiliated with any political party, candidate, or government organization.\n\nThe platform exists to understand public sentiment and encourage civic participation.",
  },
  {
    q: "Why was this platform created?",
    a: "Many citizens discuss important issues privately — in homes, WhatsApp groups, workplaces, and social media comments.\n\nKerala Speaks was created to bring those voices together in one public civic space where people can participate constructively.",
  },
  {
    q: "Are votes and messages anonymous?",
    a: "Yes. You can participate without publicly revealing your identity. Optional demographic information like district or age group may be collected to understand statewide trends, but personal identity is not displayed publicly.",
  },
  {
    q: "Why do you ask for demographic details?",
    a: "Demographic data helps identify patterns across Kerala — for example, which issues matter most in different districts, what younger citizens prioritise, and how opinions vary across communities.\n\nThe platform tracks trends, not identities.",
  },
  {
    q: "Can anyone post messages?",
    a: "Yes — as long as the content follows community guidelines. Messages containing abuse, hate speech, threats, misinformation, or harmful content may be removed or moderated.",
  },
  {
    q: "How are comments and messages moderated?",
    a: "Kerala Speaks uses a combination of automated moderation tools and manual review to keep discussions respectful and constructive.\n\nFlagged or suspicious content may be reviewed before appearing publicly.",
  },
  {
    q: "Can people upvote responses?",
    a: "Yes. Participants can support messages they agree with by upvoting them. This helps surface the issues and opinions gaining the most public support.",
  },
  {
    q: "Are poll results real?",
    a: "Yes. Poll results reflect participation from real users on the platform. Anti-spam and moderation systems are used to reduce abuse, duplicate activity, and manipulation.",
  },
  {
    q: "Will public reports be shared with leaders or media?",
    a: "Potentially, yes. One of the goals of Kerala Speaks is to create meaningful public insight reports that reflect citizen concerns and priorities.\n\nThese reports may be shared publicly, with media organisations, or with policymakers.",
  },
  {
    q: "Can I suggest a new civic question or poll?",
    a: "Yes. Kerala Speaks is designed to evolve based on public participation. Future polls and civic questions may be influenced by issues citizens raise repeatedly.",
  },
  {
    q: "How can I support or share Kerala Speaks?",
    a: "The best way to support Kerala Speaks is by participating and inviting others to participate. The more voices involved, the clearer Kerala's priorities become.",
  },
  {
    q: "Will my data be sold or used for political targeting?",
    a: "No. Kerala Speaks does not sell personal data or use participant information for political advertising or targeting.\n\nThe platform's focus is civic participation and public insight — not political profiling.",
  },
];

/** Build the schema.org FAQPage JSON-LD payload for SEO. */
export const buildFaqSchema = () => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": FAQ_ITEMS.map(({ q, a }) => ({
    "@type": "Question",
    "name": q,
    "acceptedAnswer": { "@type": "Answer", "text": a },
  })),
});
